/**
 * Created by Ibrahim Erata on 18.02.2017.
 */

export class PaginationEvent {

  constructor(public paginationScalaTitle:string,
              public isPreActive:boolean,
              public isNextActive:boolean,
              public keywords:boolean,
              public sorting:string,
              public status:boolean,
              public selectedItem:string)
  {
  }
}
